import useEnv from '../composables/useEnv'
import useRestNode from '../composables/useRestNode'

/**
 * Service for obtaining photos related to practitoners
 */
export default function usePhotoService() {

    const { get } = useRestNode()
    const { photoServiceEndpoint } = useEnv()

    const practitionerPhotos = async (results) => {
        try {
            const ids = results.map((r) => r.practitionerId)
            const url = `${photoServiceEndpoint}/api/fcp/photoinfo/v1/practitioner/thumbnails?cpnIds=${ids.toString()}`
            //console.log("Photo url", url)
            const result = await get(url)
            return result.value
        } catch (error) {
            // Handle timeout error, Error Code: ECONNABORTED
            if (error.code === 'ECONNABORTED') {
                console.error('Timeout Error: The request for practitioner photos timed out.')
                // return empty object to let the app continue
                return {}
            } else {
                console.error('Error fetching practitioner photos:', error.message)
            }
            return {
                status: 'Error',
                message: error.message || 'An error occurred',
            }
        }
    }

    const onlineClinicPhotos = async (results) => {
        try {
            const ids = results.map((r) => r.id)
            const url = `${photoServiceEndpoint}/api/fcp/photoinfo/v1/location/thumbnails?cpnIds=${ids.toString()}`
            const result = await get(url.toString())
            return result.value
        } catch (error) {
            // Handle timeout error, Error Code: ECONNABORTED
            if (error.code === 'ECONNABORTED') {
                console.error('Timeout Error: The request for online clinic photos timed out.')
                // return empty object to let the app continue
                return {}
            } else {
                console.error('Error fetching online clinic photos:', error.message)
            }
            return {
                status: 'Error',
                message: error.message || 'An error occurred',
            }
        }
    }

    const fns = { practitionerPhotos, onlineClinicPhotos }

    return fns
}